import slugify from "slugify";

slugify.extend({
    "-": "_",
    ".": "_",
    "/": "_",
    "'": "_",
    ",": "_",
    ":": "_",
    "@": "_",
    "!": "_",
    "?": "_",
    "*": "_",
});
